module.exports = __webpack_public_path__ + "static/media/googleStore.7b81b413.svg";